import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { InfoModal, RunningSimulationModal, TimesUpModal } from "../components/Modals";
import ErrorToast from "../components/Toast";
import { Sliders } from "../lib/api/league";
import { addCommasToNumber } from "../lib/general/formatting";
import { playButtonSound } from "../lib/sounds";
import "./../App.css";
import { reductionFormula } from "../lib/general/reductionFormula";

// TODO: Swap Music File
const music = require('../assets/sounds/music.mp3');

const musicAudio = new Audio(music);

export default function GameScreen() {

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!errorMessage) {
      return;
    }
    setTimeout(() => {
      setErrorMessage(null);
    }, 4000);
  }, [errorMessage])

  const navigate = useNavigate();

  const [result, setResult] = useState<{
    lapTimeReduction: number;
    remainingBudget: number;
    f1GarageScore: number;
  }>({
    lapTimeReduction: 0,
    remainingBudget: 0,
    f1GarageScore: 0,
  });

  const [userNameInput, setUserNameInput] = useState("");

  const [confirmedUser, setConfirmedUser] = useState<{
    id: string;
    username: string;
  } | null>(null);

  const [confirmingUser, setConfirmingUser] = useState(false);

  const [videoWatched, setVideoWatched] = useState(false);

  const [outroWatched, setOutroWatched] = useState(false);

  const [submittedResult, setSubmittedResult] = useState<{
    lapTimeReduction: number;
    remainingBudget: number;
    f1GarageScore: number;
  } | null>(null);

  useEffect(() => {
    
  }, [submittedResult])
  

  const usernameValid = () => {
    return userNameInput.length > 0;
  };

  const confirmUserName = async () => {
    try {
      // if (!usernameValid()) {
      //   return;
      // }
  
      // setConfirmingUser(true);
  
      // const usernameRes = await apiCreateUsername(eventId || "", userNameInput).catch((err) => {
      //   throw err;
      // });

      // if (!usernameRes) {
      //   throw new Error("Error creating username");
      // }

      // setConfirmedUser({
      //   id: usernameRes.id,
      //   username: usernameRes.username,
      // });

      setConfirmedUser({
        id: "123",
        username: "AWS Summit",
      });

    }
    catch (err) {
      setConfirmingUser(false);
      if (typeof err === "string") {
        setErrorMessage(err);
      } else {
        setErrorMessage("An unknown error occurred");
      }
    }
  }

  if (!confirmedUser) {
    return (
      <>
        <div id="site-wrapper">
          <main className="intro-screen-wrapper">
            <div className="intro-screen-main-container">
              <div className="title-section">
                <img className="logo" src={require('../assets/aws_f1_logo.png')} />
                <h1 className="huge">AWS FastTrack</h1>
                <h3>AWS Drive Your Data</h3>
              </div>
              <div className="intro-screen-input-wrapper">
                {/* <div className="large-input-container">
                  <h5>Enter the name on your pass</h5>
                  <input
                    type="text"
                    className="text-input"
                    placeholder="Your name"
                    maxLength={50}
                    onChange={(e) => {
                      setUserNameInput(e.target.value);
                    }}
                  />
                </div> */}
                <div className="wide-button-container">
                  <button type="button" disabled={confirmingUser} onClick={() => {
                    
                    playButtonSound();
                    confirmUserName();

                  }}>{
                    confirmingUser ? 'Loading...' : 'Start Game'
                  }</button>
                </div>
              </div>
            </div>
          </main>
        </div>
        <ErrorToast message={errorMessage} />
      </>
    );
  }

  if (confirmedUser && !videoWatched) {
    // Video screen with continue button

    return (
      <>
        <div id="site-wrapper">
          <main className="intro-screen-wrapper">
              <div className="title-section">
                <img className="logo" src={require('../assets/aws_f1_logo.png')} />
                <h2>AWS FastTrack Pre-race Briefing!</h2>
              </div>
              <div className="video-wrapper">
                <video controls autoPlay className="video-container" preload="auto">
                  <source src={`https://d3uhop0ye14l64.cloudfront.net/videos/intro.mp4`} type="video/mp4" />
                </video>
                <p>Watch this quick introduction to AWS FastTrack!</p>
                <div className="button-container">
                  <button type="button" onClick={() => {
                    playButtonSound();
                    musicAudio.volume = 0.3
                    musicAudio.currentTime = 0;
                    musicAudio.play()
                    setVideoWatched(true);
                  }}>Continue</button>
                </div>
              </div>
          </main>
        </div>
        <ErrorToast message={errorMessage} />
      </>
    );
  }

  if (submittedResult && !outroWatched) {
    return (
      <>
        <div id="site-wrapper">
          <main className="intro-screen-wrapper">
              <div className="title-section">
                <img className="logo" src={require('../assets/aws_f1_logo.png')} />
                <h2>And across the line!</h2>
              </div>
              <div className="video-wrapper">
                <video controls autoPlay className="video-container">
                  <source src={`https://d3uhop0ye14l64.cloudfront.net/videos/outro.mp4`} type="video/mp4" />
                </video>
                <div className="button-container">
                  <button type="button" onClick={() => {
                    playButtonSound();
                    setOutroWatched(true);
                  }}>Continue</button>
                </div>
              </div>
          </main>
        </div>
        <ErrorToast message={errorMessage} />
      </>
    )
  }

  if (submittedResult && submittedResult.remainingBudget !== undefined && submittedResult.lapTimeReduction !== undefined) {
    return (
      <>
        <div id="site-wrapper">
          <main className="intro-screen-wrapper">
            <div className="intro-screen-main-container">
              <div>
                {/* TODO: Powered by AWS Logo */}
                <h1 className="huge">YOUR SCORE</h1>
              </div>
              <div className="intro-screen-sub-container">
                {/* <div className="result-container">
                  <h6>AWS Drive your Data score</h6>
                  <h1>{submittedResult.f1GarageScore}</h1>
                </div> */}
                <div className="result-wrapper">
                  <div className="result-container">
                    <h6 style={{
                      textAlign: 'center',
                    }}>Resources Remaining</h6>
                    <h3>${addCommasToNumber(submittedResult.remainingBudget)}</h3>
                  </div>
                  <div className="result-container">
                    <h6>Total Reduction</h6>
                    <h3>-{submittedResult.lapTimeReduction.toFixed(2)}s</h3>
                  </div>
                </div>
              </div>
              <button type="button" onClick={() => {
                playButtonSound();
                // refresh the page

                window.location.reload();
              }}>Start again</button>
            </div>
          </main>
        </div>
        <ErrorToast message={errorMessage} />
      </>
    );
  }

  

  return <SlidersComponent name={confirmedUser.username} userId={confirmedUser.id} returnResult={(lapTimeReduction: number, remainingBudget: number, garageScore: number) => {
    setSubmittedResult({
      lapTimeReduction: lapTimeReduction,
      remainingBudget: remainingBudget,
      f1GarageScore: garageScore
    });
  } } setErrorMessage={(e) => {
    setErrorMessage(e);
  } } result={result} setResult={function (result: { lapTimeReduction: number; remainingBudget: number; f1GarageScore: number; }): void {
    setResult(result);
  } } />;
}

function SlidersComponent({ name, userId, returnResult, setErrorMessage, result, setResult }:
  { name: string, userId: string, returnResult: (lapTimeReduction: number, remainingBudget: number, garageScore: number) => void, setErrorMessage: (errorMessage: string | null) => void , result: {
  lapTimeReduction: number;
  remainingBudget: number;
  f1GarageScore: number;
} | null, setResult: (result: {
  lapTimeReduction: number;
  remainingBudget: number;
  f1GarageScore: number;
  }) => void }) {

    const [readyToSubmit, setReadyToSubmit] = useState(false);

    const [showTimeUp, setShowTimeUp] = useState(false);

    const [input, setInput] = useState({
      dragReduction: {
        value: 0,
        cost: 0,
        reduction: 0,
      },
      airflowOptimization: {
        value: 0,
        cost: 0,
        reduction: 0,
      },
      frontDownforce: {
        value: 0,
        cost: 0,
        reduction: 0,
      },
      rearDownforce: {
        value: 0,
        cost: 0,
        reduction: 0,
      },
      floor: {
        value: 0,
        cost: 0,
        reduction: 0,
      },
      suspension: {
        value: 0,
        cost: 0,
        reduction: 0,
      },
      engineReliability: {
        value: 0,
        cost: 0,
        reduction: 0,
      },
      turboReliability: {
        value: 0,
        cost: 0,
        reduction: 0,
      },
      energyRecovery: {
        value: 0,
        cost: 0,
        reduction: 0,
      },
      gearbox: {
        value: 0,
        cost: 0,
        reduction: 0,
      },
      weightRedistribution: {
        value: 0,
        cost: 0,
        reduction: 0,
      },
      weightReduction: {
        value: 0,
        cost: 0,
        reduction: 0,
      },
      softwareUpgrade: {
        value: 0,
        cost: 0,
        reduction: 0,
      },
      hardware: {
        value: 0,
        cost: 0,
        reduction: 0,
      },
    });
    
    // Init the inputs and budget
  
    useEffect(() => {
  
      // setInput()
  
      setRemainingBudget(budget);
  
    }, []);
    
    useEffect(() => {
      console.log('input changed: ', input)
    }, [input])
  
  // Initial time limit of 3 minutes (180 seconds)

  const [showTryAgain, setShowTryAgain] = useState(true);

  const [timer, setTimer] = useState("3:00");

  const timerRef = useRef<any>();

  useEffect(() => {
    clearTimer(getDeadlineTime(), input);
  }, [])

  const getDeadlineTime = () => {
    let deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + 180)
    return deadline;
  }

  const clearTimer = (e: any, inputObj: any) => {
    setTimer("5:00");    

    const id = setInterval(() => {
        startTimer(e, inputObj)
    }, 1000)

    timerRef.current = id;
  }

  const startTimer = (e: any, inputObj: any) => {
    let { total, minutes, seconds } = getRemainingTime(e);

    

    if (total <= 0) {
      setShowTryAgain(false);

      clearInterval(timerRef.current);
      
      // Click the run-simulation-btn

      const button = document.getElementById("run-simulation-btn");

      if (button) {
        button.click();
      }

    }

    if (total >= 0) {
      setTimer(
        (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds)
      )
    }
  }

  const getRemainingTime = (deadline: Date) => {

    if (new Date().getTime() > deadline.getTime()) {
      return { total: 0, minutes: 0, seconds: 0 };
    }

    let total = Math.round((deadline.getTime() - new Date().getTime()) / 1000);
    let minutes = Math.floor(total / 60);
    let seconds = Math.floor(total % 60);
    return { total, minutes, seconds };
  }
  
  const usd_format = {
    style: "currency",
    currency: "USD",
    currencyDisplay: "symbol",
    minimumFractionDigits: 0,
  };

  const budget = 7500000;

  const [infoModalOpen, setInfoModalOpen] = useState<{
    title: string;
    description: string;
  } | null>(null);

  const [remainingBudget, setRemainingBudget] = useState<number>(budget);

  const progress_bar = useRef<any>(null);

  const [submittingResult, setSubmittingResult] = useState(false);

  useEffect(() => {
    console.log('result changed: ', result)
  }, [result])

  function updateRangeSlider(
    slider:
      | "dragReduction"
      | "airflowOptimization"
      | "frontDownforce"
      | "rearDownforce"
      | "floor"
      | "suspension"
      | "engineReliability"
      | "turboReliability"
      | "energyRecovery"
      | "gearbox"
      | "weightRedistribution"
      | "weightReduction"
      | "softwareUpgrade"
      | "hardware",
    value: number
  ) {
    const bubbleElement = document.querySelector(
      `.bubble[data-number-value="${value}"]`
    ) as any;
    if (bubbleElement) {
      bubbleElement.style.setProperty("--slider-value", `${value}%`);
    }

    const spend = getSpend();
    
    
    

    const remaining = (budget - (spend - input[slider].cost));

    
    

    const dollarValueOfInput = getDollarValue(slider, value);

    if ((remaining - dollarValueOfInput) < 0) {
      return;
    }

    setInput({
      ...input,
      [slider]: {
        value: Number(value),
        cost: dollarValueOfInput,
        reduction: getBubbleLapTimeValue(slider, value),
      },
    });

    setRemainingBudget(remaining - dollarValueOfInput);

    (progress_bar as any).current.style.width = `${
      100 - (getSpend() / budget) * 100
    }%`;
  }

  function getSpend() {
    // Loop through each input and get the cost

    let totalCost = 0;

    for (const [key, value] of Object.entries(input)) {
      totalCost += value.cost;
    }

    return totalCost;
  }

  function getDollarValue(
    range_name:
      | "dragReduction"
      | "airflowOptimization"
      | "frontDownforce"
      | "rearDownforce"
      | "floor"
      | "suspension"
      | "engineReliability"
      | "turboReliability"
      | "energyRecovery"
      | "gearbox"
      | "weightRedistribution"
      | "weightReduction"
      | "softwareUpgrade"
      | "hardware",
    value: number
  ) {
    switch (range_name) {
      case "dragReduction":
        return Math.floor(value ** 3.1);
      case "airflowOptimization":
        return Math.floor(value ** 3.3);
      case "frontDownforce":
        return Math.floor(value ** 3);
      case "rearDownforce":
        return Math.floor(value ** 3);
      case "floor":
        return Math.floor(value ** 2.95);
      case "suspension":
        return Math.floor(value ** 3.3);
      case "engineReliability":
        return Math.floor(value ** 2.98);
      case "turboReliability":
        return Math.floor(value ** 2.87);
      case "energyRecovery":
        return Math.floor(value ** 3.1);
      case "gearbox":
        return Math.floor(value ** 3);
      case "weightRedistribution":
        return Math.floor(value ** 3.1);
      case "weightReduction":
        return Math.floor(value ** 3.1);
      case "softwareUpgrade":
        return Math.floor(value ** 2.95);
      case "hardware":
        return Math.floor(value ** 2.85);
      default:
        return 0; // Default value if range_name is not recognized
    }
  }

  function getRangeValue(
    range_name:
      | "dragReduction"
      | "airflowOptimization"
      | "frontDownforce"
      | "rearDownforce"
      | "floor"
      | "suspension"
      | "engineReliability"
      | "turboReliability"
      | "energyRecovery"
      | "gearbox"
      | "weightRedistribution"
      | "weightReduction"
      | "softwareUpgrade"
      | "hardware",
    value: number
  ) {
    switch (range_name) {
      case "dragReduction":
        return Math.floor(value ** (1 / 3.1));
      case "airflowOptimization":
        return Math.floor(value ** (1 / 3.3));
      case "frontDownforce":
        return Math.floor(value ** (1 / 3));
      case "rearDownforce":
        return Math.floor(value ** (1 / 3));
      case "floor":
        return Math.floor(value ** (1 / 2.95));
      case "suspension":
        return Math.floor(value ** (1 / 3.3));
      case "engineReliability":
        return Math.floor(value ** (1 / 2.98));
      case "turboReliability":
        return Math.floor(value ** (1 / 2.87));
      case "energyRecovery":
        return Math.floor(value ** (1 / 3.1));
      case "gearbox":
        return Math.floor(value ** (1 / 3));
      case "weightRedistribution":
        return Math.floor(value ** (1 / 3.1));
      case "weightReduction":
        return Math.floor(value ** (1 / 3.1));
      case "softwareUpgrade":
        return Math.floor(value ** (1 / 2.95));
      case "hardware":
        return Math.floor(value ** (1 / 2.85));
      default:
        return 0; // Default value if range_name is not recognized
    }
  }

  function getBubbleLapTimeValue(
    range_name:
      | "dragReduction"
      | "airflowOptimization"
      | "frontDownforce"
      | "rearDownforce"
      | "floor"
      | "suspension"
      | "engineReliability"
      | "turboReliability"
      | "energyRecovery"
      | "gearbox"
      | "weightRedistribution"
      | "weightReduction"
      | "softwareUpgrade"
      | "hardware",
    value: number
  ) {
    switch (range_name) {
      case "dragReduction":
        return Number(((value / 100) * 0.5).toFixed(2));
      case "airflowOptimization":
        return Number(((value / 100) * 0.8).toFixed(2));
      case "frontDownforce":
        return Number(((value / 100) * 0.5).toFixed(2));
      case "rearDownforce":
        return Number(((value / 100) * 0.8).toFixed(2));
      case "floor":
        return Number(((value / 100) * 0.8).toFixed(2));
      case "suspension":
        return Number(((value / 100) * 0.5).toFixed(2));
      case "engineReliability":
        return Number(((value / 100) * 0.2).toFixed(2));
      case "turboReliability":
        return Number(((value / 100) * 0.5).toFixed(2));
      case "energyRecovery":
        return Number(((value / 100) * 0.8).toFixed(2));
      case "gearbox":
        return Number(((value / 100) * 0.2).toFixed(2));
      case "weightRedistribution":
        return Number(((value / 100) * 0.2).toFixed(2));
      case "weightReduction":
        return Number(((value / 100) * 0.5).toFixed(2));
      case "softwareUpgrade":
        return Number(((value / 100) * 0.5).toFixed(2));
      case "hardware":
        return Number(((value / 100) * 0.2).toFixed(2));
      default:
        return "0.00"; // Default value if range_name is not recognized
    }
  }

  const submitResult = async () => {
    try {

      let sliders: Sliders = {
        dragReduction: input.dragReduction.value,
        airflowOptimization: input.airflowOptimization.value,
        frontDownforce: input.frontDownforce.value,
        rearDownforce: input.rearDownforce.value,
        floor: input.floor.value,
        suspension: input.suspension.value,
        engineReliability: input.engineReliability.value,
        turboReliability: input.turboReliability.value,
        energyRecovery: input.energyRecovery.value,
        gearbox: input.gearbox.value,
        weightRedistribution: input.weightRedistribution.value,
        weightReduction: input.weightReduction.value,
        softwareUpgrade: input.softwareUpgrade.value,
        hardware: input.hardware.value,
      };

      const resultRes = await reductionFormula(sliders);

      if (!resultRes) {
        throw new Error("Error submitting result");
      }

      setSubmittingResult(true);

      setResult({
        lapTimeReduction: resultRes.lapTimeReduction,
        remainingBudget: resultRes.remainingResources,
        f1GarageScore: resultRes.f1GarageScore,
      })

      musicAudio.pause();

      returnResult(resultRes.lapTimeReduction, resultRes.remainingResources, resultRes.f1GarageScore);


    }
    catch(error) {
      setSubmittingResult(false);
      if (typeof error === "string") {
        setErrorMessage(error);
      } else {
        setErrorMessage("An unknown error occurred");
      }
    }
  }

  return (
    <>
      <div id="site-wrapper">
        <main className="dashboard-wrapper">
          <div className="tile-grid">
            <div className="tile" id="game-description">
              <img id="game-description-logo" src={require('../assets/aws_f1_logo.png')} />
              <h1>AWS FastTrack</h1>
              <h2>How to Play:</h2>
              <p>
                Use the slider bars to increase specific areas of performance to
                reduce the total lap time (shown in green in seconds). With
                limited budget (bottom bar), tactical decisions need to be made
                for which areas would be best to spend budget on. Be aware that
                different areas have varying cost caps, max reduction limits and
                points of diminishing returns.
              </p>
            </div>
            <div className="tile" id="aerodynamics-tile">
              <h2 className="tile-title">Aerodynamics</h2>
              <div className="input-wrapper">
                <div className="input-container">
                  <label>
                    Drag Reduction
                  </label>
                  {/* info icon fontawesome */}
                  <FontAwesomeIcon icon={faInfoCircle} className="info-icon" onClick={() => {
                    setInfoModalOpen({
                      title: "Drag Reduction",
                      description: "Drag reduction is the process of reducing the drag force on an object moving through a fluid. In the case of an F1 car, this is the air resistance that the car experiences as it moves through the air. F1 cars produce a lot of drag as a by-product of generating the high levels of downforce required to race at such high speeds. This is a key area of performance improvement as drag directly affects the top speed and also has an impact on the acceleration of the car.",
                    });
                  }} />
                  
                  <div className="input-inner-wrapper">
                    <input
                      type="range"
                      name="drag-reduction-slider"
                      id="drag-reduction-slider"
                      className="rev-slider"
                      min="0"
                      max="100"
                      step="1"
                      value={input.dragReduction.value.toString()}
                      onChange={(e) => {
                        
                        updateRangeSlider(
                          "dragReduction",
                          e.target.value as unknown as number
                        );
                      }}
                    />
                    <output
                      className="bubble"
                      data-number-value={input.dragReduction.value.toString()}
                      data-lap-time-reduction={input.dragReduction.value.toString()}
                    >
                      $
                      {addCommasToNumber(
                        getDollarValue("dragReduction", input.dragReduction.value)
                      )}
                    </output>
                  </div>
                  <output className="lap-time-reduction">
                    +
                    {getBubbleLapTimeValue(
                      "dragReduction",
                      input.dragReduction.value
                    )}
                  </output>
                </div>
                <div className="input-container">
                  <label>Airflow Optimization</label>
                  {/* info icon fontawesome */}
                  <FontAwesomeIcon icon={faInfoCircle} className="info-icon" onClick={() => {
                    setInfoModalOpen({
                      title: "Airflow Optimization",
                      description: "Airflow optimization is the process of improving the flow of air over and through the car. The more efficiently the air flows around the car, the more efficiently the car will produce downforce, meaning less drag for a given level of downforce.",
                    });
                  }} />
                  <div className="input-inner-wrapper">
                    <input
                      type="range"
                      name="airflow-optimization-slider"
                      id="airflow-optimization-slider"
                      className="rev-slider"
                      min="0"
                      max="100"
                      step="1"
                      value={input.airflowOptimization.value.toString()}
                      onChange={(e) => {
                        
                        updateRangeSlider(
                          "airflowOptimization",
                          e.target.value as unknown as number
                        );
                      }}
                    />
                    <output
                      className="bubble"
                      data-number-value={input.airflowOptimization.value.toString()}
                      data-lap-time-reduction={input.airflowOptimization.value.toString()}
                    >
                      $
                      {addCommasToNumber(
                        getDollarValue(
                          "airflowOptimization",
                          input.airflowOptimization.value
                        )
                      )}
                    </output>
                  </div>
                  <output className="lap-time-reduction">
                    +
                    {getBubbleLapTimeValue(
                      "airflowOptimization",
                      input.airflowOptimization.value
                    )}
                  </output>
                </div>
                <div className="input-container">
                  <label>Front Downforce</label>
                  {/* info icon fontawesome */}
                  <FontAwesomeIcon icon={faInfoCircle} className="info-icon" onClick={() => {
                    setInfoModalOpen({
                      title: "Front Downforce",
                      description: "Front downforce is the amount of force pushing the front of the car down onto the track, generated mainly by the aerodynamic load produced by the front wing. The more downforce the front of the car has, the more grip the front tires will have, improving the car’s turn in to the corner. The front wing is also vital in managing the airflow that flows over the rest of car, which means that the front wing has a big impact on the entire car’s aerodynamic package.",
                    });
                  }} />
                  <div className="input-inner-wrapper">
                    <input
                      type="range"
                      name="front-downforce-slider"
                      id="front-downforce-slider"
                      className="rev-slider"
                      min="0"
                      max="100"
                      step="1"
                      value={input.frontDownforce.value.toString()}
                      onChange={(e) => {
                        
                        updateRangeSlider(
                          "frontDownforce",
                          e.target.value as unknown as number
                        );
                      }}
                    />
                    <output
                      className="bubble"
                      data-number-value={input.frontDownforce.value.toString()}
                      data-lap-time-reduction={input.frontDownforce.value.toString()}
                    >
                      $
                      {addCommasToNumber(
                        getDollarValue(
                          "frontDownforce",
                          input.frontDownforce.value
                        )
                      )}
                    </output>
                  </div>
                  <output className="lap-time-reduction">
                    +
                    {getBubbleLapTimeValue(
                      "frontDownforce",
                      input.frontDownforce.value
                    )}
                  </output>
                </div>
                <div className="input-container">
                  <label>Rear Downforce</label>
                  {/* info icon fontawesome */}
                  <FontAwesomeIcon icon={faInfoCircle} className="info-icon" onClick={() => {
                    setInfoModalOpen({
                      title: "Rear Downforce",
                      description: "Rear downforce is the amount of force pushing the rear of the car down onto the track. The more downforce the rear of the car has, the more grip the rear tires will have. The correct amount of balance with aerodynamic load on the rest of the car will improve the stability of the car in the corners, enabling the driver to push harder and ultimately reduce the lap time.",
                    });
                  }} />
                  <div className="input-inner-wrapper">
                    <input
                      type="range"
                      name="rear-downforce-slider"
                      id="rear-downforce-slider"
                      className="rev-slider"
                      min="0"
                      max="100"
                      step="1"
                      value={input.rearDownforce.value.toString()}
                      onChange={(e) => {
                        
                        updateRangeSlider(
                          "rearDownforce",
                          e.target.value as unknown as number
                        );
                      }}
                    />
                    <output
                      className="bubble"
                      data-number-value={input.rearDownforce.value.toString()}
                      data-lap-time-reduction={input.rearDownforce.value.toString()}
                    >
                      $
                      {addCommasToNumber(
                        getDollarValue("rearDownforce", input.rearDownforce.value)
                      )}
                    </output>
                  </div>
                  <output className="lap-time-reduction">
                    +
                    {getBubbleLapTimeValue(
                      "rearDownforce",
                      input.rearDownforce.value
                    )}
                  </output>
                </div>
                <div className="input-container">
                  <label>Floor</label>
                  {/* info icon fontawesome */}
                  <FontAwesomeIcon icon={faInfoCircle} className="info-icon" onClick={() => {
                    setInfoModalOpen({
                      title: "Floor",
                      description: "In this current era of F1, the floor coupled with the rear diffuser has the biggest impact on car performance. The regulations that came into force in 2022 focus the design philosophy on a phenomenon called ‘ground effect’. This is where air is rapidly forced through venturi tunnels under the car, accelerating the air which produces very low pressure underneath the car and subsequently sucks it to the ground. It is a highly efficient way of producing downforce and reducing turbulence.",
                    });
                  }} />
                  <div className="input-inner-wrapper">
                    <input
                      type="range"
                      name="floor-slider"
                      id="floor-slider"
                      className="rev-slider"
                      min="0"
                      max="100"
                      step="1"
                      value={input.floor.value.toString()}
                      onChange={(e) => {
                        
                        updateRangeSlider(
                          "floor",
                          e.target.value as unknown as number
                        );
                      }}
                    />
                    <output
                      className="bubble"
                      data-number-value={input.floor.value.toString()}
                      data-lap-time-reduction={input.floor.value.toString()}
                    >
                      $
                      {addCommasToNumber(
                        getDollarValue("floor", input.floor.value)
                      )}
                    </output>
                  </div>
                  <output className="lap-time-reduction">
                    +{getBubbleLapTimeValue("floor", input.floor.value)}
                  </output>
                </div>
              </div>
            </div>
            <div className="tile" id="vehicle-dynamics-tile">
              <h2 className="tile-title">Vehicle Dynamics</h2>
              <div className="input-wrapper">
                <div className="input-container">
                  <label>Suspension</label>
                  {/* info icon fontawesome */}
                  <FontAwesomeIcon icon={faInfoCircle} className="info-icon" onClick={() => {
                    setInfoModalOpen({
                      title: "Suspension",
                      description: "Suspension manages the relationship between the chassis of the car and the wheels, and how the wheels interact with the track. In F1 it also has an aerodynamic impact too, as suspension components are within free stream airflow. Upgrades can improve the handling of the car and help to direct and clean up airflow that will be worked by aerodynamic components further down the car.",
                    });
                  }} />
                  <div className="input-inner-wrapper">
                    <input
                      type="range"
                      name="suspension-slider"
                      id="suspension-slider"
                      className="rev-slider"
                      min="0"
                      max="100"
                      step="1"
                      value={input.suspension.value.toString()}
                      onChange={(e) => {
                        
                        updateRangeSlider(
                          "suspension",
                          e.target.value as unknown as number
                        );
                      }}
                    />
                    <output
                      className="bubble"
                      data-number-value={input.suspension.value.toString()}
                      data-lap-time-reduction={input.suspension.value.toString()}
                    >
                      $
                      {addCommasToNumber(
                        getDollarValue("suspension", input.suspension.value)
                      )}
                    </output>
                  </div>
                  <output className="lap-time-reduction">
                    +{getBubbleLapTimeValue("suspension", input.suspension.value)}
                  </output>
                </div>
              </div>
            </div>
            <div className="tile" id="powertrain-tile">
              <h2 className="tile-title">Powertrain</h2>
              <div className="input-wrapper">
                <div className="input-container">
                  <label>Engine Reliability</label>
                  {/* info icon fontawesome */}
                  <FontAwesomeIcon icon={faInfoCircle} className="info-icon" onClick={() => {
                    setInfoModalOpen({
                      title: "Engine Reliability",
                      description: "Investing in the reliability of your engine can reduce the risk of engine failure and improve the performance of the car. A more reliable engine also means that the team can run the engine harder producing more power. With the current regulations teams are not allowed to develop the power unit for performance purposes – they are only allowed to improve the reliability. Therefore, working on the reliability is the only way of generating more performance within the power unit development freeze that will last until 2025.",
                    });
                  }} />
                  <div className="input-inner-wrapper">
                    <input
                      type="range"
                      name="engine-reliability-slider"
                      id="engine-reliability-slider"
                      className="rev-slider"
                      min="0"
                      max="100"
                      step="1"
                      value={input.engineReliability.value.toString()}
                      onChange={(e) => {
                        
                        updateRangeSlider(
                          "engineReliability",
                          e.target.value as unknown as number
                        );
                      }}
                    />
                    <output
                      className="bubble"
                      data-number-value={input.engineReliability.value.toString()}
                      data-lap-time-reduction={input.engineReliability.value.toString()}
                    >
                      $
                      {addCommasToNumber(
                        getDollarValue(
                          "engineReliability",
                          input.engineReliability.value
                        )
                      )}
                    </output>
                  </div>
                  <output className="lap-time-reduction">
                    +
                    {getBubbleLapTimeValue(
                      "engineReliability",
                      input.engineReliability.value
                    )}
                  </output>
                </div>
                <div className="input-container">
                  <label>Turbo Reliability</label>
                  {/* info icon fontawesome */}
                  <FontAwesomeIcon icon={faInfoCircle} className="info-icon" onClick={() => {
                    setInfoModalOpen({
                      title: "Turbo Reliability",
                      description: "The turbocharger is also within the power unit development freeze. Investing in the reliability of your turbo can reduce the risk of turbo failure and allows the team to push it harder improving the performance of the power unit.",
                    });
                  }} />
                  <div className="input-inner-wrapper">
                    <input
                      type="range"
                      name="turbo-reliability-slider"
                      id="turbo-reliability-slider"
                      className="rev-slider"
                      min="0"
                      max="100"
                      step="1"
                      value={input.turboReliability.value.toString()}
                      onChange={(e) => {
                        
                        updateRangeSlider(
                          "turboReliability",
                          e.target.value as unknown as number
                        );
                      }}
                    />
                    <output
                      className="bubble"
                      data-number-value={input.turboReliability.value.toString()}
                      data-lap-time-reduction={input.turboReliability.value.toString()}
                    >
                      $
                      {addCommasToNumber(
                        getDollarValue(
                          "turboReliability",
                          input.turboReliability.value
                        )
                      )}
                    </output>
                  </div>
                  <output className="lap-time-reduction">
                    +
                    {getBubbleLapTimeValue(
                      "turboReliability",
                      input.turboReliability.value
                    )}
                  </output>
                </div>
                <div className="input-container">
                  <label>Energy Recovery</label>
                  {/* info icon fontawesome */}
                  <FontAwesomeIcon icon={faInfoCircle} className="info-icon" onClick={() => {
                    setInfoModalOpen({
                      title: "Energy Recovery",
                      description: "The energy recovery system includes the energy store (battery), both the MGU-H (motor generator unit – heat) MGU-K (kinetic) and the control electronics. All of these components are also bound by the power unit freeze that extends to 2025. Efficiently recovering energy from braking and the turbo charger will enable the car to utilise the energy as a boost though electric motors when accelerating, ultimately reducing lap time.",
                    });
                  }} />
                  <div className="input-inner-wrapper">
                    <input
                      type="range"
                      name="energy-recovery-slider"
                      id="energy-recovery-slider"
                      className="rev-slider"
                      min="0"
                      max="100"
                      step="1"
                      value={input.energyRecovery.value.toString()}
                      onChange={(e) => {
                        
                        updateRangeSlider(
                          "energyRecovery",
                          e.target.value as unknown as number
                        );
                      }}
                    />
                    <output
                      className="bubble"
                      data-number-value={input.energyRecovery.value.toString()}
                      data-lap-time-reduction={input.energyRecovery.value.toString()}
                    >
                      $
                      {addCommasToNumber(
                        getDollarValue(
                          "energyRecovery",
                          input.energyRecovery.value
                        )
                      )}
                    </output>
                  </div>
                  <output className="lap-time-reduction">
                    +
                    {getBubbleLapTimeValue(
                      "energyRecovery",
                      input.energyRecovery.value
                    )}
                  </output>
                </div>
                <div className="input-container">
                  <label>Gearbox</label>
                  {/* info icon fontawesome */}
                  <FontAwesomeIcon icon={faInfoCircle} className="info-icon" onClick={() => {
                    setInfoModalOpen({
                      title: "Gearbox",
                      description: "The gearbox is what transmits power from the engine to the rear wheels. As this is a passive part, meaning it doesn’t produce any power itself, there are three main performance metrics that are important to its function within the car; efficiency, weight and durability. Ultimately, teams are developing it to be as reliable as possible with the lowest weight, while minimising the power loss within the gearbox as it transmits power to the wheels.",
                    });
                  }} />
                  <div className="input-inner-wrapper">
                    <input
                      type="range"
                      name="gearbox-slider"
                      id="gearbox-slider"
                      className="rev-slider"
                      min="0"
                      max="100"
                      step="1"
                      value={input.gearbox.value.toString()}
                      onChange={(e) => {
                        
                        updateRangeSlider(
                          "gearbox",
                          e.target.value as unknown as number
                        );
                      }}
                    />
                    <output
                      className="bubble"
                      data-number-value={input.gearbox.value.toString()}
                      data-lap-time-reduction={input.gearbox.value.toString()}
                    >
                      $
                      {addCommasToNumber(
                        getDollarValue("gearbox", input.gearbox.value)
                      )}
                    </output>
                  </div>
                  <output className="lap-time-reduction">
                    +{getBubbleLapTimeValue("gearbox", input.gearbox.value)}
                  </output>
                </div>
              </div>
            </div>
            <div className="tile" id="weight-management-tile">
              <h2 className="tile-title">Weight Management</h2>
              <div className="input-wrapper">
                <div className="input-container">
                  <label>Weight Reduction</label>
                  {/* info icon fontawesome */}
                  <FontAwesomeIcon icon={faInfoCircle} className="info-icon" onClick={() => {
                    setInfoModalOpen({
                      title: "Weight Reduction",
                      description: "This metric is simple; the lower the weight, the faster the car will go. This impacts the lap time the entire way around the track, enabling the car to accelerate and go through corners faster and brake later. Every gram of weight that can be removed counts, so teams will look at everything from the smallest bolt to the weight of the paint.",
                    });
                  }} />
                  <div className="input-inner-wrapper">
                    <input
                      type="range"
                      name="weight-reduction-slider"
                      id="weight-reduction-slider"
                      className="rev-slider"
                      min="0"
                      max="100"
                      step="1"
                      value={input.weightReduction.value.toString()}
                      onChange={(e) => {
                        
                        updateRangeSlider(
                          "weightReduction",
                          e.target.value as unknown as number
                        );
                      }}
                    />
                    <output
                      className="bubble"
                      data-number-value={input.weightReduction.value.toString()}
                      data-lap-time-reduction={input.weightReduction.value.toString()}
                    >
                      $
                      {addCommasToNumber(
                        getDollarValue(
                          "weightReduction",
                          input.weightReduction.value
                        )
                      )}
                    </output>
                  </div>
                  <output className="lap-time-reduction">
                    +
                    {getBubbleLapTimeValue(
                      "weightReduction",
                      input.weightReduction.value
                    )}
                  </output>
                </div>
                <div className="input-container">
                  <label>Weight Redistribution</label>
                  {/* info icon fontawesome */}
                  <FontAwesomeIcon icon={faInfoCircle} className="info-icon" onClick={() => {
                    setInfoModalOpen({
                      title: "Weight Redistribution",
                      description: "The distribution of weight across the car can have a significant impact on the performance, and the balance of the car. Too much weight at the rear can understeer in corner entry, due to the naturally light front end, and create a pendulum effect which can lead to the car spinning out. Optimizing this balance, front to rear, is vital to enable the driver to extract the best lap time possible.",
                    });
                  }} />
                  <div className="input-inner-wrapper">
                    <input
                      type="range"
                      name="weight-redistribution-slider"
                      id="weight-redistribution-slider"
                      className="rev-slider"
                      min="0"
                      max="100"
                      step="1"
                      value={input.weightRedistribution.value.toString()}
                      onChange={(e) => {
                        
                        updateRangeSlider(
                          "weightRedistribution",
                          e.target.value as unknown as number
                        );
                      }}
                    />
                    <output
                      className="bubble"
                      data-number-value={input.weightRedistribution.value.toString()}
                      data-lap-time-reduction={input.weightRedistribution.value.toString()}
                    >
                      $
                      {addCommasToNumber(
                        getDollarValue(
                          "weightRedistribution",
                          input.weightRedistribution.value
                        )
                      )}
                    </output>
                  </div>
                  <output className="lap-time-reduction">
                    +
                    {getBubbleLapTimeValue(
                      "weightRedistribution",
                      input.weightRedistribution.value
                    )}
                  </output>
                </div>
              </div>
            </div>
            <div className="tile" id="electronics-tile">
              <h2 className="tile-title">Electronics</h2>
              <div className="input-wrapper">
                <div className="input-container">
                  <label>Software Upgrade</label>
                  {/* info icon fontawesome */}
                  <FontAwesomeIcon icon={faInfoCircle} className="info-icon" onClick={() => {
                    setInfoModalOpen({
                      title: "Software Upgrade",
                      description: "Electronics are a vital part of every F1 car – without them the cars simply wouldn’t run. Electronics control everything from the engine to the differential, so developing the most efficient software to run all of these important parts is crucial to extracting the highest performance from the car.",
                    });
                  }} />
                  <div className="input-inner-wrapper">
                    <input
                      type="range"
                      name="software-upgrade-slider"
                      id="software-upgrade-slider"
                      className="rev-slider"
                      min="0"
                      max="100"
                      step="1"
                      value={input.softwareUpgrade.value.toString()}
                      onChange={(e) => {
                        
                        updateRangeSlider(
                          "softwareUpgrade",
                          e.target.value as unknown as number
                        );
                      }}
                    />
                    <output
                      className="bubble"
                      data-number-value={input.softwareUpgrade.value.toString()}
                      data-lap-time-reduction={input.softwareUpgrade.value.toString()}
                    >
                      $
                      {addCommasToNumber(
                        getDollarValue(
                          "softwareUpgrade",
                          input.softwareUpgrade.value
                        )
                      )}
                    </output>
                  </div>
                  <output className="lap-time-reduction">
                    +
                    {getBubbleLapTimeValue(
                      "softwareUpgrade",
                      input.softwareUpgrade.value
                    )}
                  </output>
                </div>
                <div className="input-container">
                  <label>Hardware</label>
                  {/* info icon fontawesome */}
                  <FontAwesomeIcon icon={faInfoCircle} className="info-icon" onClick={() => {
                    setInfoModalOpen({
                      title: "Hardware",
                      description: "The quality of the hardware used in a Formula 1 car can have a significant impact on the performance of the car. Reliability and accuracy are the two factors at play here. Sample rates and data transfer speeds are extremely important to maximising performance.",
                    });
                  }} />
                  <div className="input-inner-wrapper">
                    <input
                      type="range"
                      name="hardware-slider"
                      id="hardware-slider"
                      className="rev-slider"
                      min="0"
                      max="100"
                      step="1"
                      value={input.hardware.value.toString()}
                      onChange={(e) => {
                        
                        updateRangeSlider(
                          "hardware",
                          e.target.value as unknown as number
                        );
                      }}
                    />
                    <output
                      className="bubble"
                      data-number-value={input.hardware.value.toString()}
                      data-lap-time-reduction={input.hardware.value.toString()}
                    >
                      $
                      {addCommasToNumber(
                        getDollarValue("hardware", input.hardware.value)
                      )}
                    </output>
                  </div>
                  <output className="lap-time-reduction">
                    +{getBubbleLapTimeValue("hardware", input.hardware.value)}
                  </output>
                </div>
              </div>
            </div>
          </div>
          <div className="results-wrapper">
            <div className="button-container">
              <button
                id="run-simulation-btn"
                onClick={() => {
                  playButtonSound();
                  setSubmittingResult(true);
                }}
              >
                Run Simulation
              </button>
            </div>
            <div id="game-time-tile">
              <h2>Total Lap Time Reduction:</h2>
              <p>
                <time id="total-reduction">
                  {result && result.lapTimeReduction
                    ? result.lapTimeReduction.toFixed(2)
                    : "0.00"}
                  s
                </time>
              </p>
            </div>
            <div id="game-time-tile" style={{
              backgroundColor: "white"
            }}>
              <h2>Time Remaining:</h2>
              <h2>{timer}</h2>
            </div>
            <div id="price-progress-wrapper">
              <div className="remaining-budget-container">
                <p id="remaining-budget">
                  ${addCommasToNumber(budget - getSpend())}
                </p>
              </div>
              <div className="progress-bar-container">
                <div ref={progress_bar} className="progress-bar"></div>
              </div>
            </div>
          </div>
        </main>
        <footer>
          <script src="./inc/js/functions.js"></script>
        </footer>
      </div>
      {
        submittingResult && (
          <RunningSimulationModal readyToSubmitChecker={(progress: number) => {
            submitResult();
          }} />
        )
      }
      {
        infoModalOpen && (
          <InfoModal title={infoModalOpen.title} description={infoModalOpen.description} onDismiss={() => {
            setInfoModalOpen(null)
          }} />
        )
      }
      {
        showTimeUp && (
          <TimesUpModal onSubmit={() => {
            submitResult();
          }} />
        )
      }
    </>
  );
}
